var map = {
	"./arrow.svg": 294,
	"./calendar.svg": 295,
	"./cross.svg": 296,
	"./facebook.svg": 297,
	"./fat-facebook.svg": 298,
	"./file.svg": 299,
	"./flickr.svg": 300,
	"./folder.svg": 301,
	"./footer-logo.svg": 302,
	"./google-plus.svg": 303,
	"./instagram.svg": 304,
	"./linkedin.svg": 305,
	"./logo.svg": 306,
	"./mail.svg": 307,
	"./marker.svg": 308,
	"./menu.svg": 309,
	"./open-external.svg": 310,
	"./price.svg": 311,
	"./privacy.svg": 312,
	"./quote.svg": 313,
	"./search.svg": 314,
	"./skew-box-front.svg": 315,
	"./skew-box-overview.svg": 316,
	"./skew-box-page.svg": 317,
	"./skew-box-swiper.svg": 318,
	"./snapchat.svg": 319,
	"./twitter.svg": 320,
	"./vimeo.svg": 321,
	"./wedge.svg": 322,
	"./youtube.svg": 323
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 87;



//////////////////
// WEBPACK FOOTER
// ./svgs \.svg$
// module id = 87
// module chunks = 1